var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIPage',[_c('UIPageHeader',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.canAddPushMessage},on:{"click":function($event){return _vm.addPushMarketingMessage()}}},[_vm._v(" Добавить ")])]},proxy:true}])}),_c('CSection',[_c('v-card',[_c('CPushMarketingMessagesDataTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }